import React, { useState, useRef } from 'react';
import { ELEMENT_UL } from '@udecode/plate';
import {
  useEditorState,
  setElements,
  getPluginType,
  isBlock,
  focusEditor,
  useEventPlateId,
} from '@udecode/plate-common';
import { getListItemEntry, toggleList } from '@udecode/plate-list';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';
import { BlockToolbarButton } from '../button/BlockToolbarButton';

import './list-dropdown.scss';

export const ListDropdown = ({ id, ...props }) => {

  const [open, setOpen] = useState(false);
  const ref = useRef();

  const editor = useEditorState(useEventPlateId(id));

  const res = !!editor?.selection && getListItemEntry(editor);

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const setListType = (e, style) => {
    if (!res || res.list[0].type !== ELEMENT_UL) {
      toggleList(editor, { type: getPluginType(editor, ELEMENT_UL) });
    }

    e.stopPropagation();
    e.preventDefault();

    const match = (n) => {
      return (
        isBlock(editor, n) &&
        n.type === ELEMENT_UL
      );
    };
    setElements(
      editor,
      { listStyleType: style },
      { match },
    );
    setTimeout(() => {
      focusEditor(editor);
      dismiss();
    }, 0);
  };

  const trigger = (
    <ToolbarDropdownButton
      className="button--unstyled toolbar-dropdown__button"
    >
      <FontAwesomeIcon
        icon={['fal', 'chevron-down']}
        size="xs"
      />
    </ToolbarDropdownButton>
  );

  return (
    <div
      ref={ref}
      className="plate-dropdown-button-combo"
    >
      <BlockToolbarButton
        name="Bulleted list"
        active={!!res && res.list[0].type === ELEMENT_UL}
        type={ELEMENT_UL}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          toggleList(editor, { type: getPluginType(editor, ELEMENT_UL) });
          setTimeout(() => {
            focusEditor(editor);
          }, 0);
        }}
        icon={<FontAwesomeIcon icon={['fa', 'list-ul']} />}
        {...props}
      />
      <ToolbarDropdown
        isOpen={open}
        show={show}
        dismiss={dismiss}
        DropdownButton={trigger}
        name="list-dropdown"
        className="plate-toolbar__dropdown-button list-dropdown"
        root={null}
      >
        <>
          <button
            className="button--unstyled button--editor-menu"
            onClick={(e) => setListType(e, 'disc')}
            onMouseDown={(e) => e.preventDefault()}
          >
            <ul className="slate-ul slate-ul--disc"><li>Disc</li></ul>
          </button>
          <button
            className="button--unstyled button--editor-menu"
            onClick={(e) => setListType(e, 'circle')}
            onMouseDown={(e) => e.preventDefault()}
          >
            <ul className="slate-ul slate-ul--circle"><li>Circle</li></ul>
          </button>
          <button
            className="button--unstyled button--editor-menu"
            onClick={(e) => setListType(e, 'square')}
            onMouseDown={(e) => e.preventDefault()}
          >
            <ul className="slate-ul slate-ul--square"><li>Square</li></ul>
          </button>
          <button
            className="button--unstyled button--editor-menu"
            onClick={(e) => setListType(e, 'dash')}
            onMouseDown={(e) => e.preventDefault()}
          >
            <ul className="slate-ul slate-ul--dash"><li>Dash</li></ul>
          </button>
        </>
      </ToolbarDropdown>
    </div>

  );
};
